var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestCancellation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.109375,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F8D4D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2008 17.8483L20.6098 19.4393L19.0188 17.8483L17.9582 18.909L19.5492 20.5L17.9582 22.091L19.0188 23.1517L20.6098 21.5607L22.2008 23.1517L23.2615 22.091L21.6705 20.5L23.2615 18.909L22.2008 17.8483Z",
    fill: "#B74641"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6094 26.5C17.3094 26.5 14.6094 23.8 14.6094 20.5C14.6094 17.2 17.3094 14.5 20.6094 14.5C23.9094 14.5 26.6094 17.2 26.6094 20.5C26.6094 23.8 23.9094 26.5 20.6094 26.5ZM20.6094 16C18.1344 16 16.1094 18.025 16.1094 20.5C16.1094 22.975 18.1344 25 20.6094 25C23.0844 25 25.1094 22.975 25.1094 20.5C25.1094 18.025 23.0844 16 20.6094 16Z",
    fill: "#B74641"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1094 8.5C25.1094 7.675 24.4344 7 23.6094 7H20.6094V5.5H19.1094V7H13.1094V5.5H11.6094V7H8.60938C7.78437 7 7.10938 7.675 7.10938 8.5V23.5C7.10938 24.325 7.78437 25 8.60938 25H13.1094V23.5H8.60938V8.5H11.6094V10H13.1094V8.5H19.1094V10H20.6094V8.5H23.6094V13H25.1094V8.5Z",
    fill: "#B74641"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestCancellation);
export default __webpack_public_path__ + "static/media/requestCancellation.4643efa7729001582a5b59aa342be0b3.svg";
export { ForwardRef as ReactComponent };